// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.contact-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 60px 20px;
}

.contact-content {
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  gap: 40px;
  align-items: start;
}

.contact-info {
  color: white;
  padding: 20px;
}

.contact-title {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 20px;
  line-height: 1.2;
}

.contact-description {
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 40px;
  opacity: 0.95;
}

.contact-details {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.contact-detail-item {
  display: flex;
  align-items: flex-start;
  gap: 15px;
}

.contact-icon {
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  backdrop-filter: blur(10px);
}

.contact-icon svg {
  width: 24px;
  height: 24px;
  color: white;
}

.contact-detail-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 5px;
}

.contact-detail-text {
  font-size: 0.95rem;
  opacity: 0.9;
}

.contact-form-container {
  background: white;
  border-radius: 20px;
  padding: 50px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-label {
  font-size: 0.95rem;
  font-weight: 600;
  color: #333;
}

.required {
  color: #e53e3e;
}

.form-input,
.form-textarea {
  padding: 14px 18px;
  font-size: 1rem;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  outline: none;
  transition: all 0.3s ease;
  font-family: inherit;
}

.form-input:focus,
.form-textarea:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-input::placeholder,
.form-textarea::placeholder {
  color: #a0aec0;
}

.form-textarea {
  resize: vertical;
  min-height: 120px;
}

.character-count {
  text-align: right;
  font-size: 0.85rem;
  color: #718096;
  margin-top: -16px;
}

.alert {
  padding: 14px 18px;
  border-radius: 10px;
  font-size: 0.95rem;
  font-weight: 500;
  margin-bottom: 10px;
}

.alert-success {
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.alert-error {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.submit-button {
  padding: 16px 32px;
  font-size: 1.05rem;
  font-weight: 600;
  color: white;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.submit-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.submit-button:active {
  transform: translateY(0);
}

.submit-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 968px) {
  .contact-content {
    grid-template-columns: 1fr;
  }

  .contact-info {
    text-align: center;
  }

  .contact-details {
    align-items: center;
  }

  .contact-detail-item {
    flex-direction: column;
    text-align: center;
    align-items: center;
  }

  .contact-form-container {
    padding: 35px;
  }
}

@media (max-width: 640px) {
  .contact-title {
    font-size: 2.2rem;
  }

  .contact-form-container {
    padding: 25px;
  }

  .contact-container {
    padding: 40px 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ContactUs.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;;EAEE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".contact-page {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.contact-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 60px 20px;\n}\n\n.contact-content {\n  display: grid;\n  grid-template-columns: 1fr 1.5fr;\n  gap: 40px;\n  align-items: start;\n}\n\n.contact-info {\n  color: white;\n  padding: 20px;\n}\n\n.contact-title {\n  font-size: 3rem;\n  font-weight: 700;\n  margin-bottom: 20px;\n  line-height: 1.2;\n}\n\n.contact-description {\n  font-size: 1.1rem;\n  line-height: 1.6;\n  margin-bottom: 40px;\n  opacity: 0.95;\n}\n\n.contact-details {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n}\n\n.contact-detail-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 15px;\n}\n\n.contact-icon {\n  width: 48px;\n  height: 48px;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  backdrop-filter: blur(10px);\n}\n\n.contact-icon svg {\n  width: 24px;\n  height: 24px;\n  color: white;\n}\n\n.contact-detail-title {\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin-bottom: 5px;\n}\n\n.contact-detail-text {\n  font-size: 0.95rem;\n  opacity: 0.9;\n}\n\n.contact-form-container {\n  background: white;\n  border-radius: 20px;\n  padding: 50px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);\n}\n\n.contact-form {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-label {\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #333;\n}\n\n.required {\n  color: #e53e3e;\n}\n\n.form-input,\n.form-textarea {\n  padding: 14px 18px;\n  font-size: 1rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 10px;\n  outline: none;\n  transition: all 0.3s ease;\n  font-family: inherit;\n}\n\n.form-input:focus,\n.form-textarea:focus {\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.form-input::placeholder,\n.form-textarea::placeholder {\n  color: #a0aec0;\n}\n\n.form-textarea {\n  resize: vertical;\n  min-height: 120px;\n}\n\n.character-count {\n  text-align: right;\n  font-size: 0.85rem;\n  color: #718096;\n  margin-top: -16px;\n}\n\n.alert {\n  padding: 14px 18px;\n  border-radius: 10px;\n  font-size: 0.95rem;\n  font-weight: 500;\n  margin-bottom: 10px;\n}\n\n.alert-success {\n  background: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.alert-error {\n  background: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n.submit-button {\n  padding: 16px 32px;\n  font-size: 1.05rem;\n  font-weight: 600;\n  color: white;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n}\n\n.submit-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n}\n\n.submit-button:active {\n  transform: translateY(0);\n}\n\n.submit-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n@media (max-width: 968px) {\n  .contact-content {\n    grid-template-columns: 1fr;\n  }\n\n  .contact-info {\n    text-align: center;\n  }\n\n  .contact-details {\n    align-items: center;\n  }\n\n  .contact-detail-item {\n    flex-direction: column;\n    text-align: center;\n    align-items: center;\n  }\n\n  .contact-form-container {\n    padding: 35px;\n  }\n}\n\n@media (max-width: 640px) {\n  .contact-title {\n    font-size: 2.2rem;\n  }\n\n  .contact-form-container {\n    padding: 25px;\n  }\n\n  .contact-container {\n    padding: 40px 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
